let defaultState = {
  home: {
    name: '',
    score: 0,
    fouls: 0,
  },
  away: {
    name: '',
    score: 0,
    fouls: 0,
  },
  timer: 0,
  timeString: '',
  paused: false,
  running: false,
  set: false,
  timerStarted: false,
  count_down: false,
  logo_url: null,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SETUP_MATCH':
      return {
        ...state,
        home: {
          ...state.home,
          name: action.home.name,
        },
        away: {
          ...state.home,
          name: action.away.name,
        },
        set: true,
        match_id: action.match_id,
      }
    case 'START_MATCH':
      return {
        ...state,
        running: true,
        count_down: action.count_down !== undefined ? action.count_down : state.count_down,
        timer: action.timer !== undefined ? action.timer : state.timer,
      }
    case 'PAUSE_MATCH':
      return {
        ...state,
        paused: true,
      }
    case 'RESUME_MATCH':
      return {
        ...state,
        paused: false,
        timer: action.timer !== undefined ? action.timer : state.timer,
      }
    case 'RESET_MATCH':
      return {
        ...defaultState,
        timerStarted: state.timerStarted,
      }
    case 'UPDATE_MATCH':
      return {
        ...state,
        home: {
          ...state.home,
          score: action.home.score,
        },
        away: {
          ...state.away,
          score: action.away.score,
        },
        timer: action.timer,
        paused: false,
        count_down: action.count_down !== undefined ? action.count_down : state.count_down,
      }
    case 'UPDATE_FOULS':
      return {
        ...state,
        home: {
          ...state.home,
          fouls: action.home.fouls,
        },
        away: {
          ...state.away,
          fouls: action.away.fouls,
        },
      }
    case 'SET_LOGO':
      return {
        ...state,
        logo_url: action.url,
      }
    case 'TIMER_START':
      return {
        ...state,
        timerStarted: true,
      }
    case 'TIMER_TICK':
      if (!state.running || state.paused) return state
      return {
        ...state,
        timer: state.count_down
          ? Math.max(0, state.timer - 1)
          : state.timer + 1,
      }
    default:
      return state
  }
}
